

























// const pathToRegexp = require('path');
import { compile, pathToRegexp } from "path-to-regexp";
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";

@Component
export default class AppBreadcrumbs extends Vue {
  levelList: any[] = [];

  created() {
    this.getBreadcrumb();
  }

  get breadcrumb() {
    return this.$store.getters.breadcrumb;
  }

  @Watch("breadcrumb")
  onBreadcrumbWatch(val) {
    if (!val) {
      return;
    }
    for (const item of this.levelList) {
      item.last = false;
    }
    this.levelList.push({ title: val.title, last: true });
  }

  @Watch("$route")
  onRouteWatch() {
    this.$store.commit("SET_BREADCUMB");
    this.getBreadcrumb();
  }

  getBreadcrumb() {
    this.levelList = this.$route.matched
      .filter(
        (item) => item.meta && item.meta.title && item.meta.breadcrumb !== false
      )
      .map((item) => ({
        title: item.meta.title,
        path: item.path,
        redirect: item.redirect,
      }));
    if (this.levelList.length > 0) {
      this.levelList[this.levelList.length - 1]["last"] = true;
    }
  }
  pathCompile(path) {
    const { params } = this.$route;
    const toPath = compile(path);
    return toPath(params);
  }
  handleLink(item) {
    const { redirect, path } = item;
    if (redirect) {
      if (typeof redirect === "function") {
        this.$router.push(redirect());
      } else {
        this.$router.push(redirect);
      }
      return;
    }
    this.$router.push(this.pathCompile(path));
  }
}
